import styled from 'styled-components';
import { motion } from 'framer-motion';

export const PageSection = styled(motion.section)`
  padding: 10rem 5rem 8rem;
  max-width: 1320px;
  margin: 0 auto;
  min-height: 60vh;

  @media (max-width: 768px) {
    padding: 10rem 1.5rem 4rem;
  }
`;

export const PageTitle = styled(motion.h1)`
  font-size: 3rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 1rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const PageSubtitle = styled.p`
  font-size: 1.1rem;
  color: #6b7280;
  margin-bottom: 3rem;
  max-width: 700px;
  line-height: 1.7;
`;

export const PageText = styled.p`
  font-size: 1.1rem;
  color: #4b5563;
  margin-bottom: 1.5rem;
  line-height: 1.8;
  max-width: 800px;
`;
